"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkListLayout = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const LinkListLayout = ({
  data,
  modulePosition,
  debug,
  className
}) => {
  const {
    title,
    linkItems
  } = data;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (linkItems.length < 1) {
    return (0, _utils.getModulesContentError)({
      debug,
      modulePosition,
      layout: _constants.LINK_LIST_LAYOUT_NAME
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.LINK_LIST_ROOT),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
      "data-testid": getTestId(_constants.LINK_LIST_TITLE),
      variant: "h4",
      component: "h2",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinkList, {
      children: linkItems.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinkBox, {
        href: item.link?.relativeUrl ?? '',
        "data-testid": getTestId(_constants.LINK_LIST_ITEM_LINK),
        target: item.downloadable ? '_self' : '_blank',
        download: item.downloadable,
        onClick: item.downloadable ? (0, _utils2.handleDownloadLink)(item.link?.relativeUrl, item.title) : undefined,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.LinkBoxInner, {
          children: [item.downloadable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DownloadIcon, {
            "data-testid": getTestId(_constants.LINK_LIST_DOWNLOAD_ICON)
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.LinkIcon, {
            "data-testid": getTestId(_constants.LINK_LIST_LINK_ICON)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
            "data-testid": getTestId(_constants.LINK_LIST_ITEM_TITLE),
            children: item.title
          })]
        })
      }, item.link?.relativeUrl ?? item.title))
    })]
  });
};
exports.LinkListLayout = LinkListLayout;
